module.exports = __webpack_public_path__ + "img/de-product-classify_img_5.3194c05f.jpg";